import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderCustomService } from './loaderCustom.service';
@Component({
    selector: 'app-loader-custom',
    templateUrl: './loaderCustom.component.html',
    styleUrls: ['./loaderCustom.component.css'],
    standalone: false
})
export class LoaderCustomComponent {
  color = 'primary';
  mode = 'indeterminate';
  value = 50;
  isLoading: Subject<boolean> = this.loaderService.isLoading;
  constructor(private loaderService: LoaderCustomService) { }
}